/* Keep the gel colour menu inside the visible page, including below a sticky header. */
(() => {
  'use strict';
  const widgets = [
    'a588c78e-4fc0-4234-8060-7f98799fd691',
    'c3e4736d-f727-41a7-ba1e-e4b59fb7239a',
    'cb8dbc69-9f8b-4409-b191-375d58da3bec'
  ].map(id => `kaching-bundles-block[deal-block-id="${id}"]`).join(',');
  let frame = 0;
  const focusedOptions = new WeakMap();

  function positionMenus() {
    frame = 0;
    const viewport = window.visualViewport;
    const leftEdge = (viewport?.offsetLeft || 0) + 12;
    const rightEdge = leftEdge + (viewport?.width || innerWidth) - 24;
    const bottomEdge = (viewport?.offsetTop || 0) + (viewport?.height || innerHeight) - 12;
    let topEdge = (viewport?.offsetTop || 0) + 12;
    document.querySelectorAll('sticky-header').forEach(header => {
      const rect = header.getBoundingClientRect();
      if (rect.top <= topEdge && rect.bottom > topEdge) topEdge = rect.bottom + 12;
    });
    document.querySelectorAll(widgets).forEach(widget => {
      widget.querySelectorAll('[role="combobox"][aria-expanded="true"]').forEach(trigger => {
        const menu = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!menu) return;
        const rect = trigger.getBoundingClientRect();
        const below = Math.max(0, bottomEdge - rect.bottom - 4);
        const above = Math.max(0, rect.top - topEdge - 4);
        const downward = below >= Math.min(260, menu.scrollHeight) || below >= above;
        const height = Math.max(0, Math.min(320, downward ? below : above));
        menu.style.setProperty('--rv-menu-height', height + 'px');
        menu.classList.add('rv-gel-colour-menu');
        const measured = menu.getBoundingClientRect();
        const top = downward ? rect.bottom + 4 : rect.top - measured.height - 4;
        menu.style.setProperty('--rv-menu-top', Math.max(topEdge, Math.min(top, bottomEdge - measured.height)) + 'px');
        menu.style.setProperty('--rv-menu-left', Math.max(leftEdge, Math.min(rect.left, rightEdge - measured.width)) + 'px');

        // Keep keyboard navigation visible without scrolling the entire page.
        const activeId = trigger.getAttribute('aria-activedescendant');
        if (activeId && focusedOptions.get(menu) !== activeId) {
          focusedOptions.set(menu, activeId);
          const option = document.getElementById(activeId);
          if (!option) return;
          const optionRect = option.getBoundingClientRect();
          const menuRect = menu.getBoundingClientRect();
          if (optionRect.top < menuRect.top) menu.scrollTop -= menuRect.top - optionRect.top + 1;
          else if (optionRect.bottom > menuRect.bottom) menu.scrollTop += optionRect.bottom - menuRect.bottom + 1;
        }
      });
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(positionMenus);
  }
  const root = document.getElementById('MainContent');
  if (!root) return;
  new MutationObserver(schedule).observe(root, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['aria-expanded', 'aria-activedescendant']
  });
  window.addEventListener('scroll', schedule, {capture: true, passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('pageshow', schedule);
  schedule();
})();
